import styled from 'styled-components';

export const Onboarding4Wrapper = styled.div`
`;
